import React from "react";
import styled from "styled-components";

function CustomDivider() {
  return (
    <Container>
      <Divider></Divider>
    </Container>
  );
}

export default CustomDivider;

const Container = styled.div`
  width: 100%;
  height: 5px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Divider = styled.div`
  width: 98%;
  height: 1px;
  border: 1px solid #f5f7f8;
`;
